import React from 'react';
import classnames from 'classnames';
import { Button, Input } from 'tea-component';

import './index.scss';

interface IAnalyseFormProps extends IBaseProps {
  url: string;
  importLoading: boolean;
  hasValidationError: boolean;
  trimmedUrl: string;
  urlLabel: string;
  urlPlaceholder: string;
  importButtonText: string;
  pageNameLabel: string;
  pageNamePlaceholder: string;
  nameInputValue: string;
  onUrlChange?: (value: string) => void;
  onPageNameChange?: (value: string) => void;
  onImport?: () => void;
}

const AnalyseForm: React.FC<IAnalyseFormProps> = (props) => {
  const {
    style,
    className,
    url,
    importLoading,
    hasValidationError,
    trimmedUrl,
    urlLabel,
    urlPlaceholder,
    importButtonText,
    pageNameLabel,
    pageNamePlaceholder,
    nameInputValue,
    onUrlChange,
    onPageNameChange,
    onImport,
  } = props;

  return (
    <div style={style} className={classnames('dbh-analyse-form', className)}>
      <div className="dbh-analyse-form__url-row">
        <div
          className={classnames('dbh-analyse-form__input-shell', 'dbh-url-collection-field', {
            'dbh-url-collection-field--loading': importLoading,
            'dbh-url-collection-field--error': hasValidationError,
          })}
        >
          <span className="dbh-analyse-form__input-label dbh-url-collection-field__label">{urlLabel}</span>
          <Input
            size="full"
            disabled={importLoading}
            placeholder={urlPlaceholder}
            value={url}
            onChange={(value) => {
              onUrlChange?.(value || '');
            }}
          />
        </div>
        <Button
          className="dbh-analyse-form__import-button"
          type="weak"
          loading={importLoading}
          disabled={!trimmedUrl}
          onClick={onImport}
        >
          {importButtonText}
        </Button>
      </div>
      <div
        className={classnames('dbh-analyse-form__input-shell dbh-url-collection-field dbh-url-collection-field-name', {
          'dbh-url-collection-field--disabled': importLoading,
          'dbh-url-collection-field--error': hasValidationError,
        })}
      >
        <span className="dbh-analyse-form__input-label dbh-url-collection-field__label">{pageNameLabel}</span>
        <Input
          size="full"
          disabled={importLoading}
          placeholder={pageNamePlaceholder}
          value={nameInputValue}
          onChange={(value) => {
            onPageNameChange?.(value || '');
          }}
        />
      </div>
    </div>
  );
};

export default AnalyseForm;
